module.exports = __webpack_public_path__ + "static/media/obsidian.37a56a3a.png";